import { captureException } from "@/observability/sentry";

/**
 * The enterprise trial form's delivery, which is not decided yet.
 *
 * The published form posted to Webflow's own form backend, which goes away
 * with the subscription, and where Webflow forwarded it cannot be read from
 * here. The sales inquiry endpoint does not fit it as it stands: it requires a
 * phone number and a traffic choice this form never asks for. Until the team
 * names a destination this sends nothing: the reader is told the form did not
 * go, as the published form's own failure line says, and Sentry records every
 * attempt so none is lost unnoticed.
 */

export type EnterpriseTrial = {
  fullName: string;
  email: string;
  companyName: string;
  jobTitle: string;
  websites: string;
  challenges: string;
  expectations: string;
};

/**
 * True once a destination holds the request. Nothing does yet, so the request
 * goes nowhere, and nothing the reader typed goes to Sentry either.
 */
export async function submitEnterpriseTrial(
  _request: EnterpriseTrial
): Promise<boolean> {
  captureException(
    new Error("The enterprise trial form has no destination yet")
  );
  return false;
}
